import UplusApi from '@uplus/uplus-api';
import Qs from 'qs'
import _config from '@/config'
import env from './env'
import ua from './ua.ts'
import { defaultBase64Img } from './iconUtil'
import newUtils from './utils.ts'
import { DEFAULT_TITLE, DEFAULT_LOGO, DEFAULT_LOGO_SHARE, DEFAULT_TITLE_SHARE, DEFAULT_DESC_SHARE, INTERNAL_AUTHENTICATION_SERVICE_TEST, INTERNAL_AUTHENTICATION_SERVICE_PROD, INTERNAL_AUTHENTICATION_APPID_PROD, INTERNAL_AUTHENTICATION_APPID_TEST } from '@/config/constKeys'
import { getRuntime } from '@haier/ihaier-runtime/web';
const instance = new UplusApi();
instance.initDeviceReady()
// let ihaierSDK = null

if (process && process.env.NODE_ENV === 'test') {
  UplusApi.instance = instance
}


export default {
  ...newUtils,
  ...env, // 环境判断方法
  ...ua, // 区分各种用户代理和从哪种来源打开
  /**
   * 加载各端小程序依赖包，并加载uni依赖包
   */
  loadUniMPEnvDeps() {
    let mpenvsdkurl = ''
    if (this.isScMpWechat() || this.isScMpPeWechat() || this.isSyBirdWeChatMP() || this.isZhiJiaMP() || this.isHaierMallWechat()) {
      mpenvsdkurl = '//res.wx.qq.com/open/js/jweixin-1.3.2.js'
    } else if (this.isScMpAli()) {
      mpenvsdkurl = '//appx/web-view.min.js'
    } else if (this.isScMpByte()) {
      mpenvsdkurl = '//s3.pstatp.com/toutiao/tmajssdk/jssdk-1.0.1.js'
    } else if (this.isMpBaidu()) {
      mpenvsdkurl = '//b.bdstatic.com/searchbox/icms/searchbox/js/swan-2.0.22.js'
    } else if (this.isZhiJiaTTMP()) {
      mpenvsdkurl = '//lf1-cdn-tos.bytegoofy.com/goofy/developer/jssdk/jssdk-1.1.0.js'
    } else {
      return Promise.reject(new Error('env error, 环境不明确，检查open_source'))
    }
    return this.loadScript(mpenvsdkurl).then(() => {
      return this.loadScript('//js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js').then(() => {
        console.log('uni:', window.uni)
      })
    })
  },
  isM3U8Supported() {
    const video = document.createElement('video');
    return video.canPlayType('application/vnd.apple.mpegurl') || video.canPlayType('application/x-mpegURL');
  },
  /**
   * @description 初始化ihaier2.0sdk实例
  */
  async initLarkEnv() {
    return await getRuntime({
      appId: (this.isProdEnv() || process.env.VUE_APP_ENV === 'preview') ? INTERNAL_AUTHENTICATION_APPID_PROD : INTERNAL_AUTHENTICATION_APPID_TEST, // 您在准备阶段获取的appId，不填默认临时appId，
      authUrl: (this.isProdEnv() || process.env.VUE_APP_ENV === 'preview') ? INTERNAL_AUTHENTICATION_SERVICE_PROD : INTERNAL_AUTHENTICATION_SERVICE_TEST
    });
  },
  /**
   * @description 关闭ihaier2.0容器
  */
  async closeLarkWebView() {
    try {
      const ihaierSDK = await this.initLarkEnv()
      const closeRes = ihaierSDK.navigation.close()
      console.log('closeRes======111=======>', closeRes)
    } catch (err) {
      console.log('closeWebview error==================>', err);
    }
  },
  /**
   * @description 获取URL参数并转换成对象
  */
  getQueryParams(url = window.location.href) {
    const result = {} // 存参数得对象
    let urlObj = new URL(decodeURIComponent(url))
    const urlString = urlObj.search; // 拿到url 参数 "格式 ?name=home&age=20"
    // 利用正则表达式
    let reg = /[?&][^?&]+=[^?&]+/g;
    const found = urlString.match(reg); //拿到有符合正则得字符串，输出为数组 [ '?name=home', '&age=20' ]
    if (found) {
      found.forEach(item => {
        let temp = item.substring(1).split('='); // = 分割
        let key = temp[0];
        let value = temp[1];
        result[key] = value
      })
    }
    return result
  },
  /**
  * @description 区分环境返回客户端定义标识
  */
  getChannel() {
    let ret = 60 // m站
    if (this.isUplus()) ret = 61 // 智家app
    if (this.isSyBird()) ret = 62 // 三翼鸟app
    if (this.isShopKeeper() && this.isIos()) ret = 78 // 三翼鸟工作台ios
    if (this.isShopKeeper() && this.isAndroid()) ret = 77 // 三翼鸟工作台android
    if (this.isScMpAli()) ret = 73 // 商城支付宝小程序
    if (this.isScMpByte()) ret = 75 // 商城字节小程序
    if (this.isSyBirdWeChatMP()) ret = 103 // 三翼鸟微信小程序
    if (this.isScMpPeWechat()) ret = 104 // 海尔智家体验店私域小程序
    if (this.isSyBirdH5()) ret = 105 // 三翼鸟H5
    if (this.isSYNDP()) ret = 106 // 三翼鸟大屏购
    if (this.isMpBaidu()) ret = 107 // 三翼鸟百度小程序
    return ret
  },
  /**
   * @description 获取中台化二维码appid 
  */
  getQrAppid() {
    let ret = 10000005 // m站
    if (this.isUplus()) ret = 10000001 // 智家app
    if (this.isSyBird()) ret = 10000007 // 三翼鸟app
    if (this.isShopKeeper() && this.isIos()) ret = 10000016 // 三翼鸟工作台ios
    if (this.isShopKeeper() && this.isAndroid()) ret = 10000015 // 三翼鸟工作台android
    if (this.isScMpAli()) ret = 10000012 // 商城支付宝小程序
    if (this.isScMpByte()) ret = 10000013 // 商城字节小程序
    if (this.isSyBirdWeChatMP()) ret = 10000008 // 三翼鸟微信小程序
    if (this.isScMpPeWechat()) ret = 10000009 // 海尔智家体验店私域小程序
    if (this.isSyBirdH5()) ret = 10000017 // 三翼鸟H5
    if (this.isSYNDP()) ret = 10000018 // 三翼鸟大屏购
    if (this.isMpBaidu()) ret = 10000019 // 三翼鸟百度小程序
    return ret
  },
  /**
   * @description 邮箱校验
  */
  isEmail(email) {
    return /^[.\w-]+@[\w-]+(.[a-zA-Z]+)+$/.test(email)
  },
  isPhone(phone) {
    return /^[1]([3-9])[0-9]{9}$/.test(phone)
  },
  isIdCard(id) {
    // return /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/.test(id);
    return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(id)
  },
  isBankCard(val) {
    return /^([1-9]{1})(\d{11}|\d{15}|\d{16}|\d{17}|\d{18})$/.test(val)
  },
  isNull(str) {
    if (str === 'null' || str === null || str === undefined || str === 'undefined' || str === '0' || str === 0) {
      return true
    } else {
      return false
    }
  },
  /**
   * @returns 是否期望隐藏导航栏
   */
  shouldHideNaviBar() {
    return sessionStorage.getItem('hide_navi') === '1'
  },
  /**
   * 是否为wifi状态
   */
  isWifi() {
    return new Promise((resolve) => {
      if (this.isHaierApp()) {
        try {
          instance.initDeviceReady().then(() => {
            instance.upNetworkModule.getNetworkInfo().then((result) => {
              console.log('result networkInfo ', result)
              if (result.retData.type === 'WiFi') {
                resolve(true)
              } else {
                resolve(false)
              }
            }).catch(() => {
              resolve(false)
            });
          })
        } catch (e) {
          resolve(false)
        }
      } else {
        try {
          let wifi = true
          let ua = window.navigator.userAgent
          let con = window.navigator.connection
          // 如果是微信
          if (/MicroMessenger/.test(ua)) {
            if (ua.indexOf('WIFI') >= 0) {
              resolve(true)
            } else {
              wifi = false
            }
            // 如果支持navigator.connection
          } else if (con) {
            let network = con.type
            if (network !== 'wifi' && network !== '2' && network !== 'unknown') {
              wifi = false
            }
          }
          resolve(wifi)
        } catch (e) {
          resolve(false)
        }
      }
    })
  },
  /**
   * 是否可展示会员价
   * 爱创客、三翼鸟、掌柜APP、iHaier屏蔽
   */
  isShowMemberPrice() {
    return !(this.isSgRn() || this.isSyBird() || this.isIMaker() || this.isIhaierApp());
  },
  /**
   * 生成 GUID
   * @param
   * @returns
   */
  getGuId() {
    let guid = sessionStorage.getItem('SG-GUID')
    if (!guid) {
      guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0; var v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
      sessionStorage.setItem('SG-GUID', guid)
    }
    return guid
  },
  /**
   *  生成随机字符串
   */
  randomString(e) {
    e = e || 32;
    var t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    var a = t.length;
    var n = '';
    for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
    return n
  },
  formatNumber(number, decimals, dec = '.', sep = ',') {
    // 参数说明：
    // number：要格式化的数字
    // decimals：保留几位小数
    // dec：小数点符号
    // sep：千分位符号
    number = (number + '').replace(/[^0-9+-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number;
    var prec = !isFinite(+decimals) ? 2 : Math.abs(decimals);
    var s = '';
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec);
      return '' + Math.ceil(n * k) / k;
    };

    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    var re = /(-?\d+)(\d{3})/;
    while (re.test(s[0])) {
      s[0] = s[0].replace(re, '$1' + sep + '$2');
    }

    if ((s[1] || '').length < prec) {
      s[1] = s[1] || '';
      s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
  },
  imgToBase64(url, extOpts = { height: 0, width: 0, quality: 0, type: 'image/png' }) {
    return new Promise((resolve) => {
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      var img = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = url;
      img.onload = function () {
        canvas.height = extOpts.height || img.height;
        canvas.width = extOpts.width || img.width;
        ctx.drawImage(img, 0, 0, extOpts.height || img.width, extOpts.width || img.height);
        var dataURL = canvas.toDataURL(extOpts.type, extOpts.quality || 0.92);
        canvas = null;
        resolve(dataURL);
      };
      img.onerror = function () {
        resolve(false)
      }
    })
  },
  uplusSaveImage(base64URLArr) {
    let imgUrls = []
    if (base64URLArr instanceof Array) {
      base64URLArr.forEach(item => {
        imgUrls.push(item.split(';base64,')[1])
      });
    } else {
      imgUrls = [base64URLArr.split(';base64,')[1]]
    }
    return new Promise(resolve => {
      instance.upImageModule.saveImages({ images: imgUrls }).then(() => {
        resolve(true)
      }, () => {
        resolve(false)
      })
    })
  },

  /**
   * uplus sdk 获取APP 状态栏高度
   */
  getStatusBarHeight(){
    return new Promise((resolve) => {
      instance.getStatusBarHeight().then((result) => {
        resolve(result.retData)
      }).catch((err) => console.log('err', err));
    })
  },
  /**
   * uplus sdk 获取APP 状态栏高度
   */
  getUplusPhoneInfo(){
    return new Promise((resolve) => {
      instance.upAppinfoModule.getPhoneInfo().then((result) => {
        resolve(result.retData)
      }).catch((err) => console.log('err', err));
    })
  },
  /*
   *
   * @param {*} 智家手动打点
   */
  uplusReportPageClickEvent(options = {}) {
    return new Promise((resolve) => {
      instance.upTraceModule.reportPageClickEvent(options).then((result) => {
        resolve(result)
      }, () => {
        resolve(400)
      })
    })
  },
  /**
   * 智家 and 掌柜 app 通用分享方法
   * @param {*} options
   * title 默认 海尔智家商城
   * desc 默认 海尔智家商城
   * url 默认 当前页面url
   * thumImage 默认 海尔智家商城logo
   *
   * update by wangpengfei 2021.5.13
   * 新增ihaier内部分享功能
   */
  inAppShare(options = {}) {
    if (this.isHaierApp()) {
      return this.uplusShareModule(options)
    } else if (this.isSgRn()) {
      return this.sgRnShareModule(options)
    } else if (this.isIhaierApp()) {
      return this.ihaierShareModule(options)
    } else {
      console.log('未知app分享')
    }
  },
  ihaierShareModule(options = {}) {
    return new Promise((resolve, reject) => {
      if (window.qing) {
        resolve(window.qing)
      } else {
        this.loadScript('//i.haier.net/public/js/qing/latest/qing.js').then(res => {
          if (window.qing) {
            resolve(window.qing)
          } else {
            resolve(false)
          }
        })
      }
    }).then(res => {
      if (window.qing) {
        let shareWay = ''
        switch (options.platformType) {
          case 'WechatSession':
            shareWay = 'wechat'
            break;
          case 'WechatTimeLine':
            shareWay = 'moments'
            break;
          case 'Sina':
            shareWay = 'weibo'
            break;
          case 'QQ':
            shareWay = 'qq'
            break;
          default:
            shareWay = 'wechat,moments'
            break;
        }
        console.log('options', options)
        this.imgToBase64(options.thumImage, {
          height: 100,
          width: 100,
          quality: 0.5
        }).then(res => {
          console.log(res)
          if (res === 'gg') {
            res = 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAA4ADgDASIAAhEBAxEB/8QAGgAAAgMBAQAAAAAAAAAAAAAAAAMEBQcGAv/EAC8QAAIBBAEDAwMDAwUAAAAAAAECAwAEBREhBhIxBxNBIlFhFDJxFSOBk6Kx0vD/xAAbAQACAgMBAAAAAAAAAAAAAAADBAIFAAYHAf/EAC0RAAEDAwMCBAUFAAAAAAAAAAECAxEABCEFEkExURMiYbEUFSOR8HGBocHR/9oADAMBAAIRAxEAPwDQfUPrW9u8lcWGNuHt7KBjGzRntaVhwTsfH4rO5nZ2LOxZj5JOyaZM7O7M52zHZP3NLngmjgSZ4ZFhckJIykKxH2Pg10m1tm7ZAbQI/utLdeW+srUajOaQ5qXFaXVyha3tppkB0WjjLDf+Ki3cE1s4S4ikicjYEilTr7806kiYnNYEmJqNIaWrsjh42KsPBB0RT4ba4uy4tYJpyg7mESFu0fc68VF2PvRxBxRAIzWm+l/qBkLHL22My1zJc4+4cRK0rdzQseAQTz270CP/ABKzSN2jdXQkMp2CPg0VQahoDd054iDt71Y2+oKaTtVmr1zW29A3KydNW4kyLRwOi2tsLi2SMLMV59snmTnf86/msPc1qVjiMQOicHfXVjj5rmQn672eZQCCdFewNo8D4FQ1hCVtJSqcngA8etL6WSlaiO1ebubN3XSXVB6dmv5souXSPujh9mX6Yolcdo8AaI48+fmk9T5iLA+pnTd7mVkdf6THFNvRIZmcFm2fgnZqXbLixL9NpglMjAsUvbrbHxv9nJ1quf6nx0Fp6vW1ra2/dEsSlYmgN1z7bHhCeeefOgefik2AhS1IUmBtUegBIgCJB+2KfdUQkFJ5HuTXYYhuqsoHkxHUvTtxGOC8FmSP42Dqq646olw9rfTZnL4jLwRoYGtsbbgSxyE6BbZ4A53XQ4m6K5q0gvLlluO7Sw3V4vuga1xbwfQo/LE6rhero481j+pcRhh7GSsslLe3Vuvm9j2fqH3K8fT+N+TS1uhLru1xI24yAOkxMgfzj170ZxRSiQc/v7VkUDntCt8fNFelWit5qiq9c1Z2/WHUeOtIrbHZWWG2iGliCIQBvfyN1VT7jdkk+llOiD8GlxIZ5Ujj5d2Cqo8knwKSU024PqJBHqJoKFqbPlMGrweoXVmuczN/pp/1qiymYyGTyDX17dyyXjL2mUHtbWta418cVKkxM0f64ywSj9E4S55H9ti3aAf8gikW9lHde77Sg+1GZW3IF0o8+fPnwOa8abtmyVISB+gFELyzhZJ+9R8Fmcn0/cyT4i7a2mkXsZ1VSSN71yD8gUi6u7m8vpr25mZ7qZi7yeCxPk8U8wQNwrOD/O6U9v2/tcH8EapkBvcVxk8xms8aRE4qPRXtY3aRUVSXYgAD5NFTK0jqakAT0rRPVfoPKY7MXOUw9rLd464cyssKlmhY8kFRz275BHjwazfH5D9Fl7SS6DxrDOjuCpBADAniiiqjQLld5bbXeMUbUmEMOyjnNd+vqJhpL7PNdWNsbae+hmhENv2vcRrOWJk2dE9vOjrZ3RJ1tilxckF7lZsxOYrpQ72xi/eI+xP9rc/G9DjVFFP/ACe3mRP4I7e1L/GOc/mZp976gYSS9hmjdWSN5ZrcfpXDWp9lxGoJYgfWU4Udv0g8VmAvpbiY6Lyyud8clif+aKKOxYtWwOztz6T/ALQ3HlPHzVqPpT0Hk8jl7bKZi1ltMbbuJVWZSrTMOQAp57d6JJ8+B+Ciiuc6vfOv3KtxgJwIraLK3Q00IHXNf//Z'
          }
          window.qing.call('socialShare', {
            shareType: 3,
            shareWay,
            shareContent: {
              title: options.title,
              description: options.desc,
              thumbData: res && res.replace(/^data:image\/\w+;base64,/, ''),
              shareIconUrl: options.thumImage,
              webpageUrl: options.url
            },
            success: res => {
              console.log('socialShare', res)
            }
          });
        })
        return window.qing
      } else {
        return false
      }
    })
  },
  sgRnShareModule(options = {}) {
    return new Promise((resolve) => {
      window.postMessage(JSON.stringify({
        type: 'share',
        data: {
          title: options.title || DEFAULT_TITLE,
          content: options.desc || DEFAULT_TITLE,
          pic: options.pic || DEFAULT_LOGO,
          thumImage: options.thumImage || DEFAULT_LOGO,
          url: options.url || window.location.href,
        }
      }))
      resolve(true)
    })
  },
  /**
   *
   * @param {*} options
   * platformType String 否 平台类型: Sina（新浪） WechatSession（微信聊天）WechatTimeLine（微信朋友圈） WechatFavorite（微信收藏) QQ（QQ） QQzone（QQ空间）
   * title	String	否	分享类型为webPage时，要分享的网页的标题 ，分享类型为image时不必填"标题"
   * desc	String	否	分享类型为webPage时，要分享的网页的描述信息 ，分享类型为image时不必填"描述信息"
   * url	String	否	分享类型为webPage时，要分享的网页的URl，分享类型为image时不必填
   * image	String	否	分享类型为image时的image路径,如 'http://', 'https://', 'file://',也可以为base64编码的字符串,分享类型为webPage时不必填
   * shareType	String	否	分享类型 webPage/image/uni(小程序卡片), 请注意cordova 容器下只支持 webPage 类型
   * thumImage String	否	分享类型为webPage时的缩略图 如 'https://', 'file://'
   */
  uplusShareModule(options = {}) {
    const isSyBird = this.isSyBird()
    let url = options.url || window.location.href
    // 三翼鸟App分享的M站中需要携带open_source用来区分平台
    if (isSyBird) {
      if (url.includes('?')) {
        url = url + '&open_source=haier-app-sybird-shared-h5&custom_title=' + encodeURIComponent('三翼鸟')
      } else {
        url = url + '?open_source=haier-app-sybird-shared-h5&custom_title=' + encodeURIComponent('三翼鸟')
      }
    }

    //分享携带统计参数
    if (this.isHaierApp() && (options.platformType === 'WechatSession' || options.platformType === 'WechatTimeLine')) {
      let type = options.platformType === 'WechatSession' ? 'WXDH' : 'PYQ'
      let code = this.getBackEndChannelId()
      url = this.checkUrladdString(url, `source_type=${type}&source_code=${code}`)
    }


    console.log('options', options)
    // 临时分享逻辑，仅在工作台中应用该逻辑： 使用uplus弹窗UI的API的情况 统一换成 微信分享
    if (!options.platformType && this.isShopKeeper()) {
      options.platformType = 'WechatSession'
    }
    if (options.platformType) {
      return new Promise((resolve, reject) => {
        if (options.platformType === 'WechatSession' && options.shareType === 'uni') {
          // let programId = this.isShopKeeper() ? 'gh_7ea0a3021369' : options.shareTarget === 'isZhiJiaMP' ? 'gh_afc1f40647b0' : (this.isUplus() ? 'gh_afc1f40647b0' : 'gh_cef6cd32fb9e') // 默认三翼鸟
          
          let shareTargetApp = '', programId;
          if( this.isShopKeeper()){
            shareTargetApp = 'isShopKeeper'
          }else if(this.isUplus()){
            shareTargetApp = 'isUplus'
          }else {
            shareTargetApp = 'isSyBird'
          }

          switch(shareTargetApp){
            case 'isUplus':
              programId = 'gh_afc1f40647b0'
              break;
            case 'isShopKeeper':
              programId = 'gh_7ea0a3021369'
              break;
            case 'isSyBird':
              programId = 'gh_cef6cd32fb9e'
              break;
          }

          // let isIos = this.isIos()
          // const miniProgramTypeJson = {
          //   isProd() {
          //     return isIos ? 'WXMiniProgramTypeRelease' : 'WXMiniProgramObject.MINIPTOGRAM_TYPE_RELEASE'
          //   },
          //   isTest() {
          //     return isIos ? 'WXMiniProgramTypeTest' : 'WXMiniProgramObject.MINIPROGRAM_TYPE_TEST'
          //   }
          // }

          if (options?.thumImage?.indexOf('http') !== -1 && !options.skipBase64Encode) {
            this.imgToBase64(options.thumImage || DEFAULT_LOGO_SHARE, { width: 375, height: 375, type: 'image/jpeg', quality: 0.85 }).then(imgBaseUrl => {
              // 三翼鸟分享到微信 分享小程序卡片
              let imgBase64;
              if (imgBaseUrl) {
                imgBase64 = (imgBaseUrl + '').replace('data:image/jpeg;base64,', '')
              }
              console.log('options.thumImage======>', options.thumImage)
              let sdkParams = {
                programId: programId,
                title: options.title || DEFAULT_TITLE_SHARE,
                desc: options.desc || DEFAULT_DESC_SHARE,
                targetPath: url,
                imageData: imgBase64 || defaultBase64Img, // 部分图片无法转成base64，故添加个默认值
                thumImage: imgBase64 || options.thumImage,
                // miniProgramType: this.isProdEnv() ? '0' : '2'
              }
              if(!this.isProdEnv()){
                sdkParams.miniProgramType = '2'
              }
              instance.upShareModule.shareWechatMiniProgram(sdkParams).then((result) => {
                if (result.retCode === '000000') {
                  resolve(true)
                } else {
                  resolve(false)
                }
              }).catch(e => { console.log(e) });
            })
          } else {
            let sdkParams = {
              programId: programId,
              title: options.title || DEFAULT_TITLE_SHARE,
              desc: options.desc || DEFAULT_DESC_SHARE,
              targetPath: url,
              imageData: options.thumImage || DEFAULT_LOGO_SHARE,
              thumImage: options.thumImage || DEFAULT_LOGO_SHARE,
              // miniProgramType: this.isProdEnv() ? '0' : '2'
            }
            if(!this.isProdEnv()){
              sdkParams.miniProgramType = '2'
            }
            instance.upShareModule.shareWechatMiniProgram(sdkParams).then((result) => {
              if (result.retCode === '000000') {
                resolve(true)
              } else {
                resolve(false)
              }
            }).catch(e => { console.log(e) });
          }
        } else {
          let sdkParams = {
            platformType: options.platformType,
            title: options.title || DEFAULT_TITLE_SHARE,
            desc: options.desc || DEFAULT_DESC_SHARE,
            url: url,
            thumImage: options.thumImage ? options.thumImage.split('?')[0].replace('http:', 'https:') : DEFAULT_LOGO_SHARE,
            shareType: options.shareType || 'webPage',
            image: options.image ? options.image.split('?')[0].replace('http:', 'https:') : DEFAULT_LOGO_SHARE,
          }
          console.log('普通分享', sdkParams)
          instance.upShareModule.share(sdkParams).then((result) => {
            if (result.retCode === '000000') {
              resolve(true)
            } else {
              resolve(false)
            }
          }).catch(e => { console.log(e) });
        }
      })
    } else {
      return new Promise((resolve, reject) => {
        instance.upShareModule.showShareView({
          title: options.title || DEFAULT_TITLE_SHARE,
          desc: options.desc || DEFAULT_DESC_SHARE,
          url: url,
          image: '',
          thumImage: options.thumImage ? options.thumImage.split('?')[0].replace('http:', 'https:') : DEFAULT_LOGO_SHARE,
          shareType: options.shareType || 'webPage',
        }).then((result) => {
          if (result.retCode === '000000') {
            resolve(true)
          } else {
            resolve(false)
          }
        }).catch(e => { console.log(e) });
      })
    }
  },
  /**
   * 获取APPstorage存储的值
   * @param {*} url
   * @param {*} flag
   * @param {*} skip
   * @param {*} showheader
   * @param {*} replace
   */
  getAppStorageStringValue(storageName) {
    return new Promise((resolve, reject) => {
      instance.initDeviceReady().then(() => {
        instance.upStorageModule.getStringValue({
          storageName: storageName
        }).then(ret => {
          console.log('getAppStorageStringValue============1111111111=>', ret)
          if (ret && ret.retCode === '000000') {
            resolve(ret.retData)
          } else {
            resolve(null)
          }
        }).catch(() => {
          resolve(null)
        })
      }).catch(e => { console.log(e) });
    }).catch(e => console.log(e))
  },
  /**
   * 获取APPstorage存储的值
   * @param {*} url
   * @param {*} flag
   * @param {*} skip
   * @param {*} showheader
   * @param {*} replace
   */
  setAppStorageStringValue(storageName, storageValue) {
    return new Promise((resolve, reject) => {
      instance.initDeviceReady().then(() => {
        instance.upStorageModule.putStringValue({
          storageName,
          storageValue
        }).then(ret => {
          if (ret && ret.retCode === '000000') {
            resolve(ret)
          } else {
            reject(ret)
          }
        }).catch((error) => {
          resolve(error)
        })
      }).catch(e => { console.log(e) });
    })
  },
  /**
   * 获取APPstorage存储的值
   * @param {*} url
   * @param {*} flag
   * @param {*} skip
   * @param {*} showheader
   * @param {*} replace
   */
  getAppStorageBooleanValue(storageName) {
    return new Promise((resolve, reject) => {
      instance.initDeviceReady().then(() => {
        instance.upStorageModule.getBooleanValue({
          storageName: storageName
        }).then(ret => {
          if (ret && ret.retCode === '000000') {
            resolve(ret.retData)
          } else {
            resolve(null)
          }
        }).catch(() => {
          resolve(null)
        })
      }).catch(e => { console.log(e) });
    })
  },
  /**
     * 获取APPstorage存储的值
     * @param {*} url
     * @param {*} flag
     * @param {*} skip
     * @param {*} showheader
     * @param {*} replace
     */
  setAppStorageBooleanValue(storageName, storageValue) {
    return new Promise((resolve, reject) => {
      instance.initDeviceReady().then(() => {
        instance.upStorageModule.putBooleanValue({
          storageName,
          storageValue
        }).then(ret => {
          if (ret && ret.retCode === '000000') {
            resolve(ret)
          } else {
            reject(ret)
          }
        }).catch((error) => {
          resolve(error)
        })
      }).catch(e => { console.log(e) });
    })
  },

  /**
   * 获取APPstorage存储的值
   * @param {*} url
   * @param {*} flag
   * @param {*} skip
   * @param {*} showheader
   * @param {*} replace
   */
  getAppStorageLongValue(storageName) {
    return new Promise((resolve, reject) => {
      instance.initDeviceReady().then(() => {
        instance.upStorageModule.getLongValue({
          storageName: storageName
        }).then(ret => {
          if (ret && ret.retCode === '000000') {
            resolve(ret.retData)
          } else {
            resolve(null)
          }
        }).catch(() => {
          resolve(null)
        })
      }).catch(e => { console.log(e) });
    })
  },
  /**
   * 获取APPstorage存储的值
   * @param {*} url
   * @param {*} flag
   * @param {*} skip
   * @param {*} showheader
   * @param {*} replace
   */
  setAppStorageLongValue(storageName, storageValue) {
    return new Promise((resolve, reject) => {
      instance.initDeviceReady().then(() => {
        instance.upStorageModule.putLongValue({
          storageName,
          storageValue
        }).then(ret => {
          if (ret && ret.retCode === '000000') {
            resolve(ret)
          } else {
            reject(ret)
          }
        }).catch((error) => {
          resolve(error)
        })
      }).catch(e => { console.log(e) });
    })
  },
  /**
   *
   * @param {*} url 跳转地址
   * @param {*} flag 表示是否为完整url
   * @param {*} skip 表示是否跳过 拼接 container_type=3&show_title_bar=true&hidesBottomBarWhenPushed=1
   * @param {*} showheader 是否带原生头
   * @param {*} replace 是否替换url
   *
   */
  getOpenNewWindowUrl({  url, flag, skip, showheader, containerType=3 }){
    let targetUrl = flag ? url : _config.HOST + url
    if (this.isHaierApp()) {
      if (!skip) {
        if (targetUrl.indexOf('#') !== -1) {
          let arr = targetUrl.split('#')
          let startStr = arr[0];
          let endStr = arr[1];
          if (arr[0].indexOf('?') !== -1) {
            startStr += `&container_type=${containerType}&show_title_bar=${showheader}&hidesBottomBarWhenPushed=1`
          } else {
            startStr += `?container_type=${containerType}&show_title_bar=${showheader}&hidesBottomBarWhenPushed=1`
          }
          targetUrl = startStr + '#' + endStr
        } else {
          if (targetUrl.indexOf('?') !== -1) {
            targetUrl += `&container_type=${containerType}&show_title_bar=${showheader}&hidesBottomBarWhenPushed=1`
          } else {
            targetUrl += `?container_type=${containerType}&show_title_bar=${showheader}&hidesBottomBarWhenPushed=1`
          }
        }
      }
      return targetUrl
    } else {
      return targetUrl
    }
  },
  /**
   *
   * @param {*} url 跳转地址
   * @param {*} flag 表示是否为完整url
   * @param {*} skip 表示是否跳过 拼接 container_type=3&show_title_bar=true&hidesBottomBarWhenPushed=1
   * @param {*} showheader 是否带原生头
   * @param {*} replace 是否替换url
   *
   */
  openNewWindow(url, flag, skip = false, showheader = true, replace = false, newtab=false) {
    let targetUrl = decodeURI(this.getOpenNewWindowUrl({ url, flag, skip, showheader }))//处理特殊字符转义问题先解码再编码
    if (this.isHaierApp()) {
      instance.initDeviceReady().then(() => {
        // instance.vdnModule.vdnEngine.goToPage({ url: targetUrl });
        // log txt with red color
        console.log(encodeURI(targetUrl),'color: red');
        
        instance.upVdnModule.goToPage({ url: encodeURI(targetUrl) });
      }).catch(e => { console.log(e) });
    } else {
      if (replace) {
        window.location.replace(targetUrl)
      }else if(newtab){
        window.open(targetUrl, '_blank')
      } else {
        window.location.href = targetUrl
      }
    }
  },
  loadScript(url, elemId) {
    return new Promise((resolve, reject) => {
      if (elemId && document.getElementById(elemId)) {
        resolve();
        return;
      }
      var script = document.createElement('script')
      script.type = 'text/javascript';
      if (elemId) script.id = elemId
      if (script.readyState) { // IE
        script.onreadystatechange = function () {
          if (script.readyState === 'loaded' || script.readyState === 'complete') {
            script.onreadystatechange = null;
            resolve();
          }
        };
      } else { // Others
        script.onload = function () {
          resolve();
        };
      }
      script.src = url;
      document.getElementsByTagName('head')[0].appendChild(script);
    })
  },
  /**
   *
   * @param {*} 检测是否安装APP schema协议
   * @returns
   */
  testInstallApp(url, installCb, unInstallCb) {
    var timeout = null;
    var t = 1000; var hasApp = true;
    setTimeout(function () {
      if (hasApp) {
        installCb()
      } else {
        unInstallCb()
      }
      document.body.removeChild(ifr);
    }, 2000)

    var t1 = Date.now();
    var ifr = document.createElement('iframe');
    ifr.setAttribute('src', url);
    ifr.setAttribute('style', 'display:none');
    document.body.appendChild(ifr);
    timeout = setTimeout(function () {
      clearTimeout(timeout)
      var t2 = Date.now();
      if (!t1 || t2 - t1 < t + 100) {
        hasApp = false;
      }
    }, t);
  },
  numberToDouble(num) {
    return (num = num < 10 ? ('0' + num) : num);
  },
  winTorem() {
    (function (win) {
      var doc = win.document;
      var docEl = doc.documentElement;
      var tid;
      function refreshRem() {
        var width = docEl.getBoundingClientRect().width;
        if (width > 750) width = 750;
        var rem = width / 7.5;
        docEl.style.fontSize = rem + 'px';
      }
      win.addEventListener('resize', function () {
        clearTimeout(tid);
        tid = setTimeout(refreshRem, 300);
      }, false);
      win.addEventListener('pageshow', function (e) {
        if (e.persisted) {
          clearTimeout(tid);
          tid = setTimeout(refreshRem, 300);
        }
      }, false);
      refreshRem();
    })(window)
  },
  netWorkStatusHandler(onFn, offFn) {
    window.addEventListener('online', () => {
      onFn && onFn()
    }, false);
    window.addEventListener('offline', () => {
      offFn && offFn()
    }, false);
  },
  /**
   * 拉起APP
   * @param {*} Openinstall H5
   * type 1、智家APP 2、三翼鸟APP
   * @param {*} id  不能为空
   */
  openInstall(id, type, targetUrl = location.href) {
    let context = this
    if (targetUrl.indexOf('?') !== -1) {
      targetUrl = targetUrl + '&container_type=3&hidesBottomBarWhenPushed=1'
    } else {
      targetUrl = targetUrl + '?container_type=3&hidesBottomBarWhenPushed=1'
    }
    console.log(targetUrl, 'targetUrl')
    this.loadScript('//res.cdn.openinstall.io/openinstall.js', 'openinstallJS').then(() => {
      // openinstall初始化时将与openinstall服务器交互，应尽可能早的调用
      /* web页面向app传递的json数据(json string/js Object)，应用被拉起或是首次安装时，通过相应的android/ios api可以获取此数据 */
      // var data = OpenInstall.parseUrlParams();//openinstall.js中提供的工具函数，解析url中的所有查询参数
      // console.log('data',data)
      // eslint-disable-next-line no-new
      try {
        new OpenInstall({ // eslint-disable-line no-undef
          /* appKey必选参数，openinstall平台为每个应用分配的ID */
          appKey: +type === 1 ? 'vghhgm' : 'f7x9re',
          /* 可选参数，自定义android平台的apk下载文件名；个别andriod浏览器下载时，中文文件名显示乱码，请慎用中文文件名！ */
          // apkFileName : 'com.fm.openinstalldemo-v2.2.0.apk',
          /* 可选参数，是否优先考虑拉起app，以牺牲下载体验为代价 */
          // preferWakeup:true,/*自定义遮罩的html*/
          // mask:function(){
          // return "<div id='openinstall_shadow' style='position:fixed;left:0;top:0;background:rgba(0,255,0,0.5);filter:alpha(opacity=50);width:100%;height:100%;z-index:10000;'></div>"
          // },
          /* openinstall初始化完成的回调函数，可选 */
          onready: function () {
            var m = this; var button = document.getElementById(id);
            // button.style.visibility = 'visible';
            /* 在app已安装的情况尝试拉起app */
            // m.schemeWakeup();
            /* 用户点击某个按钮时(假定按钮id为downloadButton)，安装app */
            if (button) {
              button.onclick = function () {
                context.gioTrackWithVariable('mall_download_app')
                try {
                  m.wakeupOrInstall({ timeout: 5000 });
                } catch (error) { }
                return false;
              }
            }
          }
        }, {
          targetUrl: targetUrl + '&browerFirstIn=0',
          type: 'launchToPage'
        });
      } catch (error) {
        console.log(error)
      }
      
    }).catch(e => console.log(e))
  },

  /**
   * 拉起翼逛App
   */
  openShopKeeper(targetUrl) {
    return new Promise((resolve) => {
      window.location.href = targetUrl !== 'undefined' ? 'eguang://target/' + targetUrl : 'eguang://target/'
      this.setTimeOutFn(() => {
        console.log('未安装翼逛app')
        resolve(false)
      }, 2000)
    })
  },
  /**
   * 拉起顺逛App 失败后去下载地址
   */
  openShunguang() {
    // window.location.href = 'https://sj.qq.com/myapp/detail.htm?apkName=com.ehaier.shunguang&info=F9F585B7C3D39714E8A752027F6F7091';
    // window.location.href = 'https://apps.apple.com/cn/app/%E6%99%BA%E5%AE%B6%E6%8E%8C%E6%9F%9C-%E4%BD%A0%E7%9A%84%E6%8E%8C%E4%B8%8A%E6%99%BA%E6%85%A7%E5%BA%97%E9%93%BA/id1035160364?l=zh';
    window.location.href = 'shunguang://'
    setTimeout(function () {
      let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
      if (typeof hidden === 'undefined' || hidden === false) {
        window.location.href = 'https://sg.ehaier.com'
      }
    }, 2000);
  },
  // 数美短信服务skd
  smMsgSdk() {
    // 数美sdk ==start==
    window._smReadyFuncs = []; window.SMSdk = {
      ready: function (fn) {
        fn && window._smReadyFuncs.push(fn);
      }
    };
    // 1. 通用配置项
    window._smConf = {
      organization: 'vN3ilx2xOKGaDtWdDD8u', // 必填，组织标识，邮件中 organization 项
      accessKey: '6cChZc1GgC9cQCVBzozN',
      staticHost: 'static.fengkongcloud.com',
      // 2.连接海外机房特殊配置项，仅供设备数据上报海外机房客户使用 //apiHost:'fp-sa-it.fengkongcloud.com' //连接新加坡机房客户使用此选项 //apiHost: 'fp-na-it.fengkongcloud.com' //连接到美国机房客户使用此选项
    };
    var url = (function () {
      var originHost = 'static2.fengkongcloud.com';
      var isHttps = document.location.protocol === 'https:'; var protocol = isHttps ? 'https://' : 'http://';
      var fpJsPath = '/fpv2.js';
      var url = protocol + window._smConf.staticHost + fpJsPath; var ua = navigator.userAgent.toLowerCase();
      var isWinXP = /windows\s(?:nt\s5.1)|(?:xp)/.test(ua); var isLowIE = /msie\s[678]\.0/.test(ua);
      if (isHttps && isWinXP && isLowIE) {
        url = protocol + originHost + fpJsPath;
      }
      return url;
    })();
    var sm = document.createElement('script');
    var s = document.getElementsByTagName('script')[0]; sm.src = url;
    s.parentNode.insertBefore(sm, s);
  },
  /**
   * @description  使用数美设备id
   */
  dealSmDeviceId() {
    return new Promise(resolve => {
      var smTimeoutTime = 100;
      var smDeviceId = '';
      var smDeviceIdReady = false;
      var smTimer = setTimeout(function () {
        smDeviceId = window.SMSdk.getDeviceId ? window.SMSdk.getDeviceId() : smDeviceId;
        if (!smDeviceIdReady) {
          smDeviceIdReady = true; // 执行业务逻辑
          resolve(smDeviceId);
        }
      }, smTimeoutTime);
      window.SMSdk.ready(function () {
        smDeviceId = window.SMSdk.getDeviceId ? window.SMSdk.getDeviceId() : smDeviceId; clearTimeout(smTimer);
        if (!smDeviceIdReady) {
          smDeviceIdReady = true; // 执行业务逻辑
          resolve(smDeviceId);
        }
      });
    })
  },
  /**
   * 检查浏览器是否支持webp
   * @param {String} feature
   * 'feature' can be one of 'lossy', 'lossless', 'alpha' or 'animation'
   * @param {Func} callback
   */
  checkWebpFeature(feature, callback) {
    let kTestImages = {
      lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
      lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
      alpha: 'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
      animation: 'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA'
    };
    let img = new Image();
    img.onload = function () {
      let result = (img.width > 0) && (img.height > 0);
      callback(feature, result);
    };
    img.onerror = function () {
      callback(feature, false);
    };
    img.src = 'data:image/webp;base64,' + kTestImages[feature];
  },

  // 防抖
  debounce(func, delay = 300) {
    var timeout = null
    return function () {
      if (timeout !== null) { clearTimeout(timeout) }
      timeout = setTimeout(func.bind(this), delay)
    }
  },
  debounceImmediate(func, delay = 500, immediate = true) {
    var timeout;
    return function () {
      var context = this;
      var args = arguments;
      if (timeout) clearTimeout(timeout);
      if (immediate) {
        var callNow = !timeout;
        timeout = setTimeout(function () {
          timeout = null;
        }, delay)
        if (callNow) func.apply(context, args)
      } else {
        timeout = setTimeout(function () {
          func.apply(context, args)
        }, delay);
      }
    }
  },
  // 节流
  throttle(func, delay = 300) {
    var timer = null
    return function () {
      var context = this
      var args = arguments
      if (!timer) {
        timer = setTimeout(function () {
          func.apply(context, args)
          timer = null
        }, delay)
      }
    }
  },
  // 获取指定地址参数
  parseQueryValue(name) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    let r = window.location.search.substr(1).match(reg);
    if (r != null) {
      // 对参数值进行解码
      let retVal = decodeURIComponent(r[2])
      if (isNaN(retVal)) {
        retVal = 0
      }
      return retVal ? Number(retVal) : 0
    }
    return null;
  },
  // 获取指定地址参数
  parseURLQueryValue(url, name) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    const strs = url.split('?')
    if (strs.length === 2) {
      url = '?' + strs[1]
    }
    let r = url.substr(1).match(reg);
    if (r != null) {
      // 对参数值进行解码
      let retVal = decodeURIComponent(r[2])
      return retVal;
    }
    return null;
  },

  /**
   * 微信公众号获取code
   * @param {*} options
   * appId
   * backUrl: 回跳url
   */
  getWxUserInfoCode(appid, redirectUrl) {
    if (!this.isProdEnv()) {
      appid = 'wx0345da7d994d7a18'
    }
    redirectUrl = !redirectUrl ? window.location.href : redirectUrl;
    const scope = 'snsapi_userinfo' //
    window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(redirectUrl)}&response_type=code&scope=${scope}&state=STATE#wechat_redirect`);
  },
  getWxCode(appid, redirectUrl) {
    redirectUrl = !redirectUrl ? window.location.href : redirectUrl;
    window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(redirectUrl)}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`);
  },

  /** 微信端内H5支付
   *
   * @param {*} options
   * appId
   * timeStamp
   * nonceStr
   * package
   * signType
   * paySign
   */
  InWXH5Pay(options) {
    // console.log('aaaaaaaaaaaaaaaaaaa', options)
    const onBridgeReady = () => {
      console.log(options, 'InWXH5Pay');
      // eslint-disable-next-line no-undef
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest', {
          'appId': options.appId, // 公众号名称，由商户传入
          'timeStamp': options.timeStamp, // 时间戳，自1970年以来的秒数
          'nonceStr': options.nonceStr, // 随机串
          'package': options.package,
          'signType': options.signType || 'RSA', // 微信签名方式：
          'paySign': options.paySign // 微信签名
        },
        (res) => {
          if (res.err_msg === 'get_brand_wcpay_request:ok') {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            options.success && options.success(res)
          } else {
            options.fail && options.fail(res);
          }
        }
      );
    }

    if (typeof WeixinJSBridge === 'undefined') {
      console.log('11111111')
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
        document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
      }
    } else {
      console.log('2222222')
      onBridgeReady();
    }
  },
  /**
   * @description 单位数前面加0
   * @param {*} n
  */
  formatTimeNumber(n) {
    n = n.toString()
    return n[1] ? n : `0${n}`
  },
  /**
   * @description 时间戳转化为年 月 日 时 分 秒
   * @param {Number} number 传入时间戳
   * @param {Sreing} format：返回格式，支持自定义，但参数必须与formateArr里保持一致
  */
  formatTime(number, format) {
    if (!number) {
      return ''
    }
    const formateArr = ['Y', 'M', 'D', 'h', 'm', 's']
    const returnArr = []

    const date = new Date(number)
    returnArr.push(date.getFullYear())
    returnArr.push(this.formatTimeNumber(date.getMonth() + 1))
    returnArr.push(this.formatTimeNumber(date.getDate()))

    returnArr.push(this.formatTimeNumber(date.getHours()))
    returnArr.push(this.formatTimeNumber(date.getMinutes()))
    returnArr.push(this.formatTimeNumber(date.getSeconds()))

    for (const i in returnArr) {
      format = format.replace(formateArr[i], returnArr[i])
    }
    return format
  },

  parseParamsToQuery(params) {
    let query = '?'
    if (params) {
      console.log('upHttpModule  处理 params', params)
      for (const [key, value] of Object.entries(params)) {
        if (value !== null && value !== undefined && value !== '') { // 数字 “0” 要保留, false 要保留
          query = query + key + '=' + value + '&'
        }
      }
      return query.substring(0, query.length - 1)
    }
    return ''
  },
  parseQueryToJson(query) {
    return Qs.parse(query);
  },
  /**
   * 字符型json串 处理
   * @param json str
   * @param defalutVal 默认值
   */
  strJSONParse(jsonstr, defalutVal) {
    try {
      return JSON.parse(jsonstr) || defalutVal
    } catch (err) {
      return defalutVal
    }
  },

  /**
   * @desc 智家App上报埋点
   */
  gioTrackWithVariable(eventId, variable, enableShopKeeper) {
    // gio上报参数值必须为字符串或字符串'null'
    if (variable) {
      for (const key in variable) {
        if (Object.hasOwnProperty.call(variable, key)) {
          const e = variable[key];
          if (e === undefined || e === '') {
            variable[key] = 'null'
          } else {
            variable[key] = e + ''
          }
        }
      }
    }
    console.log('gio参数转为字符串', eventId, variable)
    return new Promise((resolve, reject) => {
      if (this.isShopKeeper() && !enableShopKeeper) {
        resolve()
      } else {
        if (this.isHaierApp()) {
          try {
            instance.initDeviceReady().then(() => {
              if (variable) {
                instance.upTraceModule.gioTrackWithVariable({
                  eventId,
                  variable
                }).then(() => {
                  resolve()
                }).catch(e => console.log(e))
              } else {
                instance.upTraceModule.gioTrack({
                  eventId
                }).then(() => {
                  resolve()
                }).catch(e => console.log(e))
              }
            }).catch(e => console.log(e))
          } catch (error) {
            resolve()
          }
        } else {
          gio && gio('track', eventId, variable)
          resolve()
        }
      }
    }).catch(e => console.log(e))
  },
  async generateSignature(params) {
    console.log('generateSignature', params)
    const cryptoObj = window.crypto || window.msCrypto
    const getUtf8Bytes = str =>
      new Uint8Array(
        [...decodeURIComponent(encodeURIComponent(str))].map(c => c.charCodeAt(0))
      );
    const secretBytes = getUtf8Bytes(params.secretKey);
    const messageBytes = getUtf8Bytes(params.signingString);
    const cryptoKey = await cryptoObj.subtle.importKey(
      'raw', secretBytes, { name: 'HMAC', hash: 'SHA-256' },
      true, ['sign']
    );
    const sig = await cryptoObj.subtle.sign('HMAC', cryptoKey, messageBytes);
    // to lowercase hexits
    [...new Uint8Array(sig)].map(b => b.toString(16).padStart(2, '0')).join('');
    // to base64
    return window.btoa(String.fromCharCode(...new Uint8Array(sig)));
  },
  /**
   * @desc 小数加法精度
   */
  accAdd(arg1,arg2){  
    var r1, r2, m;  
    try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}  
    try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}  
    m=Math.pow(10,Math.max(r1,r2))  
    return (arg1*m + arg2*m) / m  
  },
  /**
   * @desc 小数乘法精度
   */
  accMul(arg1,arg2){  
    var m=0,s1=arg1.toString(),s2=arg2.toString();  
    try{m+=s1.split(".")[1].length}catch(e){}  
    try{m+=s2.split(".")[1].length}catch(e){}  
    return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)  
  },
  //优惠券规则转义方法 展示的规则信息
  showRule(data) {
    let text = ''
    let omit = data.list.length > 2 && data.omit
    if (data.type === 'brand') {
      const arr = omit ? data.list.slice(0, 2) : data.list
      const str = arr.join('、')
      text = `订单限制购买${str}${omit ? '等' : ''}品牌商品`
    } else if (data.type === 'department') {
      const arr = omit ? data.list.slice(0, 2) : data.list
      const str = arr.join('、')
      text = `订单限制购买${str}${omit ? '等' : ''}产品组商品`
    } else if (data.type === 'limitDepartmentNum') {
      text = `需要购买指定产品组${data.list}个以上`
    } else if (data.type === 'limitNum') {
      text = `需要购买指定商品至少${data.list}件`
    } else if (data.type === 'products') {
      const arr = data.list.slice(0, 2)
      const str = `<span>${data.list[0].relationShipSort === 1 ? '或' : '且'}</span>`
      text = `${data.list[0].relationShipSort === 1 ? '订单中需要包含至少一件以下商品' : '订单中需要包含以下商品'}：${arr[0]}${data.list.length > 1 ? str + arr[1] : ''}${
        omit ? '等' : ''
      }`
    }
    return text
  },
  //优惠券规则转义方法 格式化规则
  formateRules(data, omit = true /* 是否超过2个后省略 */) {
    let rules = []
    if (data.brands) {
      const brands = []
      data.brands.forEach((brand) => {
        brands.push(brand.brandName)
      })
      rules.push({
        type: 'brand',
        list: brands,
        text: this.showRule({
          type: 'brand',
          list: brands,
          omit
        }),
      })
    }
    if (data.departments) {
      const departments = []
      data.departments.forEach((department) => {
        departments.push(department.departmentName)
      })
      rules.push({
        type: 'department',
        list: departments,
        text: this.showRule({
          type: 'department',
          list: departments,
          omit
        }),
      })
    }
    if (data.limitDepartmentNum) {
      rules.push({
        type: 'limitDepartmentNum',
        list: data.limitDepartmentNum,
        text: this.showRule({
          type: 'limitDepartmentNum',
          list: data.limitDepartmentNum,
          omit
        }),
      })
    }
    if (data.limitNum) {
      rules.push({
        type: 'limitNum',
        list: data.limitNum,
        text: this.showRule({
          type: 'limitNum',
          list: data.limitNum,
          omit
        }),
      })
    }
    if (data.products) {
      const products = []
      data.products.forEach((product) => {
        products.push(product.productName)
      })
      rules.push({
        type: 'products',
        list: data.products,
        text: this.showRule({
          type: 'products',
          list: products,
          omit
        }),
      })
    }
    return rules
  },
  openMapAppByURI(url, failCb) {
    let timeout = 3000;
    let startTime = Date.now();
    // 先清理可能存在的旧iframe
    let iframe = document.getElementById('navi_iframe');
    if(iframe) {
      iframe.parentNode.removeChild(iframe);
    }
    
    let ifr = document.createElement('iframe');
    ifr.src = encodeURI(url);
    ifr.style.display = 'none';
    ifr.setAttribute('id', 'navi_iframe');
    document.body.appendChild(ifr);
    
    const cleanupIframe = () => {
      const iframe = document.getElementById('navi_iframe');
      if(iframe) {
        iframe.parentNode.removeChild(iframe);
      }
      window.removeEventListener('blur', blurHandler);
    };
    
    const blurHandler = () => {
      cleanupIframe();
      clearTimeout(t);
    };
    
    const t = setTimeout(function () {
      console.log('setTimeout');
      let endTime = Date.now();
      if (!startTime || endTime - startTime < timeout + 200) {
        failCb();
      } else {
        console.log('安装了');
      }
      cleanupIframe();
    }, timeout);
    
    window.addEventListener('blur', blurHandler);
  },
  openNaviApp(options) {
    console.log('++++++++++++++++++++++++++++++++=')
    if (this.isAndroid()) {
      let url;
      switch (options.app) {
        case 'qqmap':
          url = `qqmap://map/routeplan?type=drive&fromcoord=CurrentLocation&to=${options.name}&tocoord=${options.latitude},${options.longitude}&referer=JDLBZ-BZLLX-7K34C-Z2NYZ-GI3NJ-OIFB3`;
          break;
        case 'amap':
          url = `androidamap://route/path/?dlat=${options.latitude}&dlon=${options.longitude}&dname=${options.name}`;
          break;
        case 'bmap':
        default:
          url = `baidumap://map/direction?coord_type=wgs84&destination=name:${options.name}|latlng:${options.latitude},${options.longitude}|addr:${options.address}&src=andr.baidu.openAPIdemo`;
          break;
      }
      console.log('isAndroid', url);
      this.openMapAppByURI(url,options.failCb);
    } else if (this.isIos()) {
      let url;
      switch (options.app) {
        case 'qqmap':
          url = `qqmap://map/routeplan?type=drive&fromcoord=CurrentLocation&to=${options.name}&tocoord=${options.latitude},${options.longitude}&referer=JDLBZ-BZLLX-7K34C-Z2NYZ-GI3NJ-OIFB3`;
          break;
        case 'amap':
          url = `iosamap://path/?dlat=${options.latitude}&dlon=${options.longitude}&dname=${options.name}`;
          break;
        case 'bmap':
          url = `baidumap://map/direction?coord_type=wgs84&destination=${options.latitude},${options.longitude}&destination_region=${options.address}&src=ios.baidu.openAPIdemo`;
          break;
        case 'applemap':
        default:
          url = `maps://?daddr=${options.name}&sll=${options.latitude},${options.longitude}`
          break;
      }
      console.log('isIos', url);
      this.openMapAppByURI(url,options.failCb);
    }  else {
      let url;
      switch (options.app) {
        case 'qqmap':
          url = `qqmap://map/routeplan?type=drive&fromcoord=CurrentLocation&to=${options.name}&tocoord=${options.latitude},${options.longitude}&referer=JDLBZ-BZLLX-7K34C-Z2NYZ-GI3NJ-OIFB3`;
          break;
        case 'amap':
          url = `androidamap://route/path/?dlat=${options.latitude}&dlon=${options.longitude}&dname=${options.name}`;
          break;
        case 'bmap':
        default:
          url = `baidumap://map/direction?coord_type=wgs84&destination=name:${options.name}|latlng:${options.latitude},${options.longitude}|addr:${options.address}&src=andr.baidu.openAPIdemo`;
          break;
      }
      console.log('isAndroid', url);
      this.openNewWindow(url)
    }
  }
}
